import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../../app/store'

interface IAuthState {
  user?: {
    email?: string
    name?: string
    id?: string
    phoneNumber?: string
    roles?: string[]
    isVerified: boolean
    is2FAEnabled: boolean
    isKYCVerified?: boolean
    badges?: string[]
  } | null
  token?: string | null
  refreshToken?: string | null
}

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: localStorage.getItem('userInfo')
      ? JSON.parse(localStorage.getItem('userInfo') || '')
      : null,
    token: localStorage.getItem('token') || null,
    refreshToken: localStorage.getItem('refreshToken') || null,
  } as IAuthState,
  reducers: {
    setCredentials: (state, action) => {
      state.user = action.payload.user
      state.token = action.payload.token
      state.refreshToken = action.payload.refreshToken
      localStorage.setItem('token', action.payload.token)
      localStorage.setItem('refreshToken', action.payload.refreshToken)
      localStorage.setItem('userInfo', JSON.stringify(action.payload.user))
    },
    logout: state => {
      state.user = null
      state.token = null
      state.refreshToken = null
      localStorage.removeItem('token')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('userInfo')
    },
    updateCredentials: (state, action) => {
      state.user = action.payload.user
      localStorage.setItem('userInfo', JSON.stringify(action.payload.user))
    },
  },
})

export const { setCredentials, logout, updateCredentials } = authSlice.actions

export default authSlice.reducer

export const selectCurrentUser = (state: RootState) => state.auth.user
export const selectCurrentToken = (state: RootState) => state.auth.token
export const selectRefreshToken = (state: RootState) => state.auth.refreshToken
